import { SORT_OPTIONS } from 'domains/finance/payments/constants'
import PropTypes from 'prop-types'
import { DropdownItem, DropdownMenu, DropdownToggle, Label, UncontrolledDropdown } from 'reactstrap'

const propTypes = {
  sortBy            : PropTypes.string,
  sortDir           : PropTypes.string,
  handleSortOnClick : PropTypes.func
}

const defaultProps = {
  sortBy            : '',
  sortDir           : '',
  handleSortOnClick : () => { }
}

/**
 * Field for ordering data
 * @param {String} sortBy - attribute used for doing sort
 * @param {String} sortDir - sort direction, can be ascending or descending
 * @param {Function} handleSortOnClick - function to handle when user change sorting option
 */
const FinancePaymentsSortFilterField = ({
  sortBy,
  sortDir,
  handleSortOnClick
}) => {
  // use .find instead of filter so you dont have to access the array
  const selectedOption = SORT_OPTIONS.find(
    (option) => option.sort_by === sortBy && option.sort_dir === sortDir
  )

  return (
    <div className='d-flex flex-column'>
      <Label className='form-label'>
        { 'Sort' }
      </Label>

      <UncontrolledDropdown className='mb-3'>
        <DropdownToggle caret>
          { selectedOption.label }
        </DropdownToggle>
        <DropdownMenu>
          {
            SORT_OPTIONS.map((item) => (
              <DropdownItem
                key={ `product-sort-options-${item.label}` }
                value={ item.id }
                onClick={ () => handleSortOnClick(item) }
              >
                { item.label }
              </DropdownItem>
            ))
          }
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  )

}

FinancePaymentsSortFilterField.propTypes    = propTypes
FinancePaymentsSortFilterField.defaultProps = defaultProps

export default FinancePaymentsSortFilterField
